import {Helper} from "@nolimitcity/promo-panel/bin/utils/Helper";
import {ASMainGamePickOptions, WINTYPE} from "@nolimitcity/promo-panel/bin/enums/ASEnums";
import {
    ActionSpinOptions,
    ActionSpinSound,
    ASWinData,
    PromoPanelGameConfiguration,
} from "@nolimitcity/promo-panel/bin/interfaces/ASInterfaces";
import {Tombstone} from "./Tombstone";
import {TombstoneGameMode} from "./gamemode/TombstoneGameMode";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {TombstoneSoundConfig} from "./TombstoneSoundConfig";
import {TombstoneGameAssets} from "./TombstoneGameAssets";


export class TombstonePromoPanelConfig implements PromoPanelGameConfiguration {
    private wasFeatureBuy:boolean = false;

    constructor() {
    }

    public getActionSpinOptions():ActionSpinOptions {
        return {
            gameName:"Tombstone",
            hasActionSpin:true,
            graphics:{backgroundTextureName:TombstoneGameAssets.MAIN_GAME_BACKGROUND},
            getParsedData:(response:any, bet:number, prevResponse:any):ASWinData => {
                if (response.mode === TombstoneGameMode.NORMAL){
                    this.wasFeatureBuy = response.wasFeatureBuy;
                }
                const parsedData:ASWinData = {
                    totalWin:response.accumulatedRoundWin,
                    totalSpinWinnings:this.getWin(response, bet, prevResponse),
                    wasFeatureBuy:response.wasFeatureBuy,
                    freeSpinTriggeredThisSpin:this.isFreeSpinTriggered(response),
                    isBigWin:this.isBigWin(response),
                    winType:WINTYPE.NORMAL,
                    featureName:this.getFeatureName(response),
                    isRoundComplete:this.isRoundComplete(response),
                    isBonusEnd:this.isBonusEnd(response),
                    isWinCapHit:response.brokeTheBank
                }
                return parsedData;
            }
        };
    }

    private isBigWin(response:any):boolean {
        const win = response.totalSpinWinnings;
        const playedBetValue = response.playedBetValue;
        let winRatio:number = Helper.ceilToDecimals((win / playedBetValue), 2);

        return winRatio >= 15;
    }

    private getWin(response:any, bet:number, prevData:any):number {
        return response.totalSpinWinnings;
    }

    private getFeatureName(response:any):string {
        if (response.mode == TombstoneGameMode.RESPIN || response.nextMode == TombstoneGameMode.RESPIN){
            return "JUSTICE SPINS"
        }

        if (response.mode == TombstoneGameMode.FREESPIN || response.nextMode == TombstoneGameMode.FREESPIN){
            return "GUNSLINGER SPINS"
        }
        if (response.mode == TombstoneGameMode.SUPER_FREESPIN || response.nextMode == TombstoneGameMode.SUPER_FREESPIN){
            return "BOUNTY SPINS"
        }

        return "";
    }

    private isFreeSpinTriggered(response:any):boolean {
        const respin = response.bonusTriggeredThisSpin;
        const freespin = response.freespinTriggeredThisSpin;
        const sFs = response.mode == TombstoneGameMode.NORMAL && response.nextMode == TombstoneGameMode.SUPER_FREESPIN

        return (respin || freespin || sFs) && response.nextMode !== TombstoneGameMode.NORMAL;
    }

    private isRoundComplete(response:any):boolean {
        return ([TombstoneGameMode.NORMAL, TombstoneGameMode.RESPIN, TombstoneGameMode.FREESPIN, TombstoneGameMode.SUPER_FREESPIN].indexOf(response.nextMode) > -1);
    }

    private isBonusEnd(response:any):boolean {
        return response.nextMode === TombstoneGameMode.NORMAL && (response.mode.indexOf("NORMAL") === -1);
    }


    public onActionSpinPlaySound(trigger:ActionSpinSound):void {
        if (trigger == ActionSpinSound.WIN) {
            SlotGame.sound.playEffect(TombstoneSoundConfig.instance.AS_WIN);
        } else if (trigger == ActionSpinSound.BIG_WIN) {
            SlotGame.sound.playEffect(TombstoneSoundConfig.instance.AS_WIN_BIG);
        }
    }

/*
    onPlayBonusInGame(data:any):void {
        TheBorder.keypadPlugin.hide();
        TheBorder.model.onGame(data);
        TheBorder.apiPlugin.slotStates.resetGameStartedAndGameServerFlag();
        TheBorder.keypadPlugin.setWin(data.accumulatedRoundWin, true, TheBorder.isWinBelowStake());
        TheBorder.allReelsView.reInit();
        TheBorder.gameFlowController.start();
        TheBorder.keypadPlugin.show();
    }
*/



}